import { Component } from 'react'
import { RouterProps, withRouter } from '../../../../insfrastructure/utils/with-router-component'
import { listJobApplies } from '../../../../insfrastructure/services/job-applies'
import { listJobs } from '../../../../insfrastructure/services/jobs'
import { Stepper } from '../../unlogged-area/sign-up/company/company-form/components/stepper'
import BasicInfo from './basic-info'
import Benefits from './benefits'
import Requirements from './requirements'
import Summary from './summary'
import './styles.sass'

class JobOffer extends Component<RouterProps> {
  state: any = {
    jobpost_id: null,
    can_edit: true,
    is_editing: false,
    is_duplicating: false,
    source_jobpost_id: null, // ID da vaga original quando duplicando
    selected_step: 1,
    filled_steps: 0,
    steps: {
      basic_info: 'Dados Básicos',
      benefits: 'Salários e benefícios',
      requirements: 'Requisitos',
      resume: 'Resumo',
    },
    basic_info: {},
    benefits: {},
    requirements: {}
  }

  componentDidMount() {
    if (this.props.params?.offer_id) {
      // Edição via URL (ex: /offers/123)
      this.setState({
        jobpost_id: this.props.params?.offer_id,
        is_editing: true,
        is_duplicating: false,
      }, () => this.retriveJob());
    } else if (this.props.location?.state?.offer_id) {
      // Duplicação via state (ex: clicou em duplicar)
      this.setState({
        jobpost_id: null, // Não seta jobpost_id para garantir criação de nova vaga
        source_jobpost_id: this.props.location?.state?.offer_id, // Salva o ID original para carregar dados
        is_editing: false,
        is_duplicating: true,
      }, () => this.retrieveJobForDuplication());
    } else {
      // Criando uma nova vaga do zero
      this.setState({
        is_editing: false,
        is_duplicating: false,
      });
    }
  }

  retriveJob = async () => {
    try {
      const offer = (await listJobs({ id: this.state.jobpost_id })).data[0] as any;
      const offerStatus = offer.status?.toLowerCase() || '';
      const candidates = (await listJobApplies(this.state.jobpost_id)).length;

      // Se a vaga não for ativa OU se for ativa mas tiver candidatos, redireciona para visualização
      if (offerStatus !== 'active' || candidates > 0) {
        this.props.navigate('/offers/'+this.state.jobpost_id+'/details');
        return;
      }

      this.loadOfferData(offer);
    } catch (error) {
      // Em caso de erro, redireciona para a lista de vagas
      this.props.navigate('/offers');
    }
  }

  retrieveJobForDuplication = async () => {
    try {
      // Carrega os dados da vaga original sem aplicar regras de edição
      const offer = (await listJobs({ id: this.state.source_jobpost_id })).data[0] as any;
      this.loadOfferData(offer);
    } catch (error) {
      // Em caso de erro, redireciona para a lista de vagas
      this.props.navigate('/offers');
    }
  }

  loadOfferData = (offer: any) => {
    let state = {
      basic_info: {
        company_id: (() => {
          try {
            // Decodifica company_id se estiver em Base64
            if (offer.company.id && offer.company.id.includes('Q29tcGFueVR5cGU6')) {
              return atob(offer.company.id).split(':')[1];
            }
            return offer.company.id;
          } catch (error) {
            return offer.company.id;
          }
        })(),
        company_name: offer.company.name,
        job_title_id: parseInt(offer.jobTitle.id),
        job_type: offer.jobType.toLowerCase(),
        job_description: offer.jobDescription,
        quantity: offer.quantity
      },
      benefits: {
        salary: offer.salary,
        comission: offer.comission,
        show_salary: offer.showSalary,
        benefits: offer.jobBenefits.map((x: any) => ({
          benefit_id: x.benefitId,
          value: x.value,
          time_unit: x.timeUnit?.toLowerCase(),
          description: x.description
        }))
      },
      requirements: {
        minimum_education: offer.minimumEducation?.toLowerCase(),
        minimum_experience: offer.minimumExperience?.toString() || '0',
        required_skills: offer.jobSkills.filter((x: any) => x.skillType === 'REQUIRED').map((x: any) => parseInt(x.skill.id)),
        desired_skills: offer.jobSkills.filter((x: any) => x.skillType === 'DESIRED').map((x: any) => parseInt(x.skill.id))
      }
    };

    this.setState(state);
  }

  onFillStep = (filled_steps: number, form_name: string, form_data: Record<string, any>) => {
    this.setState({ 
      filled_steps: filled_steps > this.state.filled_steps ? filled_steps : this.state.filled_steps,
      selected_step: filled_steps + 1,
      [form_name]: form_data
    });
    
    window.scrollTo(0, 0);
  }

  onChangeStep = (selected_step: number) => {
    this.setState({ selected_step });
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className='job-offer company-page'>
        <div className='block'>
            <h3>{this.state.is_editing ? 'Editar Vaga' : (this.state.is_duplicating ? 'Duplicar Vaga' : 'Adicionar Nova Vaga')}</h3>
            <Stepper
            steps={this.state.steps}
            selectedStep={this.state.selected_step}
            filledSteps={this.state.filled_steps}
            />
            { this.state.selected_step === 1 &&
            <BasicInfo inital_data={this.state.basic_info}
            is_editing={this.state.is_editing}
            onSubmit={(basic_info) => this.onFillStep(1, 'basic_info', basic_info)} /> }
            
            { this.state.selected_step === 2 &&
            <Benefits inital_data={this.state.benefits}
            onSubmit={(benefits) => this.onFillStep(2, 'benefits', benefits)} /> }
            
            { this.state.selected_step === 3 &&
            <Requirements inital_data={this.state.requirements}
            onSubmit={(requirements) => this.onFillStep(3, 'requirements', requirements)} /> }
            
            { this.state.selected_step === 4 &&
            <Summary
            jobpost_id={this.state.jobpost_id}
            basic_info={this.state.basic_info}
            benefits={this.state.benefits}
            requirements={this.state.requirements}
            is_editing={this.state.is_editing}
            is_duplicating={this.state.is_duplicating}
            changeSection={(index: number) => this.onChangeStep(index)} /> }
        </div>
      </div>
    )
  }
}

export default withRouter(JobOffer)